import { progressBarSchema } from "@redotech/redo-conversion-settings-common/checkout-optimization-settings";
import * as z from "zod";

export const getStorefrontProgressBarSettings = {
  name: "getStorefrontProgressBarSettings" as const,
  input: z.null(),
  output: z.object({ settings: progressBarSchema.optional() }),
};
